module.exports = __webpack_public_path__ + "static/img/10areaB_06.4b12805.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_06.png
// module id = 1076
// module chunks = 1